// 时间戳转换
import md5 from 'js-md5'
import { Message } from 'element-ui'
import Axios from 'axios'

export function getTime(time) {
  const date = new Date(time)
  const y = date.getFullYear()
  const m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
  const d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
  return y + '-' + m + '-' + d
}

export function getTimeMonth(time) {
  const date = new Date(time)
  const y = date.getFullYear()
  const m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
  return y + '-' + m
}

// 时间戳转换详细
export function getAllTime(time) {
  const allDate = new Date(time)
  const y = allDate.getFullYear()
  const m = (allDate.getMonth() + 1 < 10 ? '0' + (allDate.getMonth() + 1) : allDate.getMonth() + 1)
  const d = (allDate.getDate() < 10 ? '0' + (allDate.getDate()) : allDate.getDate())
  const h = (allDate.getHours() < 10 ? '0' + (allDate.getHours()) : allDate.getHours())
  const mm = (allDate.getMinutes() < 10 ? '0' + (allDate.getMinutes()) : allDate.getMinutes())
  const ss = (allDate.getSeconds() < 10 ? '0' + (allDate.getSeconds()) : allDate.getSeconds())
  return y + '-' + m + '-' + d + ' ' + h + ':' + mm + ':' + ss
}

//判断上传文件后缀名字
export function upLoadSuffix(file) {
  var arr = ["bmp", "jpg", "png", "pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "rar", "zip", 'wps', 'dps', 'et']
  var name = file.name.split('.')[file.name.split('.').length - 1]
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] === name) {
      return true
    }
  }
  return false
}

// 一维数组转三级联动数组
export function fnSetTreeData(data) {
  const newData = [...data]
  newData.forEach((father) => {
    const branchArr = newData.filter((child) => {
      if (father.code === child.parentCode) child._hasParent = true
      return father.code === child.parentCode
    })
    // 可以让没有子元素的不显示children
    if (branchArr.length > 0) father.children = branchArr
  })
  // 都遍历完才知道谁有父级
  return data.filter((item) => {
    return !item._hasParent
  })
}

// 查找数组中的所有子节点 参数1：树形数据，参数2：节点id
export function getAllParentArr(list, id) {
  for (const i in list) {
    if (list[i].code === id) {
      // 查询到返回该数组对象
      return [list[i]]
    }
    if (list[i].children) {
      const node = getAllParentArr(list[i].children, id)
      if (node !== undefined) {
        // 查询到把父节点连起来
        return node.concat(list[i])
      }
    }
  }
}
export function authorization() {
  const tokenPrincipal = storageGetObj('token.principal')
  const tokenCredentials = storageGetObj('token.credentials')
  const timestamp = new Date().getTime()
  if (!tokenPrincipal) {
    return ''
  }
  if (!tokenCredentials) {
    return ''
  }
  let credentials = md5(tokenPrincipal + tokenCredentials)
  credentials = md5(credentials + timestamp)
  const authKey = btoa(tokenPrincipal + '.' + credentials + '.' + timestamp)
  return authKey
}

export function storagePut(key, value) {
  sessionStorage.setItem(key, value)
}

export function storageGet(key) {
  return sessionStorage.getItem(key)
}

export function storagePutObj(key, value) {
  if (!value) {
    storagePut(key, value)
  }
  sessionStorage.setItem(key, JSON.stringify(value))
}
export function storageGetObj(key) {
  const value = sessionStorage.getItem(key)
  if (!value) {
    return value
  }
  return JSON.parse(value)
}
// 获取文件拓展名
export function getFileExtByPath(path) {
  return path.substring(path.lastIndexOf('.') + 1).toLocaleLowerCase()
}
// 判断拓展名是否匹配
export function fileExtEquals(path, ext) {
  const fileExt = getFileExtByPath(path).toLocaleLowerCase()
  return ext.toLocaleLowerCase() === fileExt
}

/**
 * 把字符串中的换行符拆分出单独的 dom 标签
 * @param content 文本内容
 * @param labelName 生成的 dom 标签
 */
export function lineBrake2Dom(content, labelName) {
  if (!content) {
    return "";
  }
  let result = "";
  content.split("\n").forEach(text => {
    result += `<${labelName}>${text}</${labelName}>`
  })
  return result;
}

//
export function changeData(s) {
  let buf
  let i
  if (typeof ArrayBuffer !== 'undefined') {
    buf = new ArrayBuffer(s.length)
    const view = new Uint8Array(buf)
    for (i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
    return buf
  } else {
    buf = new Array(s.length)
    for (i = 0; i !== s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF
    return buf
  }
}

export function download(config) {
  Axios.get(config.url, {
    responseType: 'blob'
  }).then(res => {
    const data = res.data
    const fileReader = new FileReader()
    fileReader.onload = function () {
      try {
        const jsonData = JSON.parse(this.result)
        if (jsonData.status < 400) {
          return
        }
        Message({
          message: jsonData.message,
          type: 'warning'
        })
        return
      } catch (err) {
        // 解析成对象失败，说明是正常的文件流
        const blob = data
        const a = document.createElement('a')
        const url = (window.URL) ? window.URL.createObjectURL(blob) : window.webkitURL.createObjectURL(blob)
        a.href = url
        a.download = config.name
        a.click()
        window.URL.revokeObjectURL(url)
      }
    }
    fileReader.readAsText(data)
  })
}
